import { hasAnalyticsCookiesConsent } from '../tracking/onetrust';
import {
  getDataAndTrackerForAction,
  getDataAndTrackerForTrackEvent,
  getDefaultData,
} from '../tracking/prepareTrackData';
import { ANALYTICS } from '../actions/analyticsManager.actions';
import Tracker from '../tracking/tracker';

const prepareAndSendTrackingData = (action, reduxState) => {
  if (action.type === ANALYTICS) {
    // All ANALYTICS actions are tracked.
    const defaultData = getDefaultData();
    const [eventData, tracker] = getDataAndTrackerForTrackEvent(
      action.payload,
      reduxState
    );
    const trackData = { ...defaultData, ...eventData };
    Tracker.send(action.payload.event, trackData, tracker);
  } else {
    const result = getDataAndTrackerForAction(action);
    if (result === null) {
      // Do not track the action if result is null
      return;
    }

    const defaultData = getDefaultData();
    const [actionTrackData, tracker] = result;
    const trackData = { ...defaultData, ...actionTrackData };
    Tracker.send(action.type, trackData, tracker);
  }
};

const middleware = ({ getState }) => {
  return (next) => (action) => {
    if (hasAnalyticsCookiesConsent()) {
      prepareAndSendTrackingData(action, getState());
    }

    // Call the next dispatch method in the middleware chain.
    const returnValue = next(action);
    return returnValue;
  };
};

export default middleware;
try {
    // @ts-ignore
    analyticsManagermiddleware.displayName = "analyticsManagermiddleware";
    // @ts-ignore
    analyticsManagermiddleware.__docgenInfo = { "description": "", "displayName": "analyticsManagermiddleware", "props": { "getState": { "defaultValue": null, "description": "", "name": "getState", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/analyticsManager/middlewares/analyticsManager.middleware.ts#analyticsManagermiddleware"] = { docgenInfo: analyticsManagermiddleware.__docgenInfo, name: "analyticsManagermiddleware", path: "src/shared/analyticsManager/middlewares/analyticsManager.middleware.ts#analyticsManagermiddleware" };
}
catch (__react_docgen_typescript_loader_error) { }